/* Pakyo destination page — plan picker. Port of design/Pakyo Product Japan.dc.html logic.
   Data: #DestData (rendered by sections/pakyo-destination.liquid). */
(() => {
  const root = document.querySelector('[data-destination]');
  const dataEl = document.getElementById('DestData');
  if (!root || !dataEl) return;
  const DATA = JSON.parse(dataEl.textContent);
  const P = window.Pakyo;
  const CFG = DATA.page || {};
  // Sub-areas (Hawaii) show their own name but pick plans as their parent country.
  const HOME = CFG.parent || DATA.name, HOME_ISO = DATA.iso;
  // Text comes from window.PT (snippets/i18n-js.liquid, generated from i18n/*.json). Logic keeps using the English data
  // (country names, operator names, exit-IP labels); they are translated only where they're shown.
  const PT = window.PT;
  // Exit-IP spellings in the TSIM sheet that mean this destination.
  const IP_ALIASES = { 'United Kingdom': ['uk'], 'United States': ['usa'], Macau: ['macao'], Netherlands: ['netherland'] };

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = cents => P.formatMoney(Math.round(cents));
  // Codes with no flag file: Hawaii uses the US flag; Netherlands Antilles (dissolved 2010) gets a blank dot.
  const FLAG_ALIAS = { 'US-HI': 'us', AN: '' };
  const flagCode = iso => iso == null ? '' : (String(iso).toUpperCase() in FLAG_ALIAS ? FLAG_ALIAS[String(iso).toUpperCase()] : String(iso).toLowerCase());
  const flag = iso => flagCode(iso) ? `https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/1x1/${flagCode(iso)}.svg` : '';
  const flagImg = (iso, size, cls = 'flag') => !iso ? '' : flag(iso) ? `<img class="${cls}" src="${flag(iso)}" alt="" width="${size}" height="${size}" loading="lazy">` : `<span class="${cls} flag--blank" style="width:${size}px;height:${size}px"></span>`;

  /* ---------- operators ---------- */
  const OPN = o => String(o).trim(); // names are unified at import (scripts/names.py)
  const ampJoin = a => a.length <= 2 ? a.join(' & ') : a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1];
  const uniq = a => [...new Set(a)];
  const andJoin = a => PT.list(a);
  const NAME_ISO = {};
  DATA.families.forEach(f => (f.cov || []).forEach(c => { if (c && c.iso && c.name) NAME_ISO[c.name] = c.iso; }));
  const L = n => PT.country(NAME_ISO[n], n); // a country name as shown
  const HOME_L = CFG.parent ? PT.country(NAME_ISO[HOME], HOME) : DATA.label || HOME;
  const opsL = ops => PT.amp(uniq(ops.map(OPN)).map(PT.op)); // operator list as shown

  /* ---------- families, groups, plans ---------- */
  const fams = DATA.families.map(f => {
    const cov = (f.cov || []).filter(c => c && c.iso);
    const home = cov.find(c => c.iso === HOME_ISO);
    const carrier = home ? ampJoin(uniq(home.ops.map(OPN))) : '';
    const carrierL = home ? opsL(home.ops) : '';
    // Design v3: "local" = the exit IP is in this destination (single country), whatever the family is called.
    const ipName = String(f.ip || '').trim().toLowerCase();
    const isLocal = !!ipName && !/[\/,]/.test(ipName) && [HOME.toLowerCase(), ...(IP_ALIASES[HOME] || [])].includes(ipName);
    const ipi = f.ipi || {};
    const tt = /^yes/i.test(ipi.tiktok || '') ? 'yes' : /ios/i.test(ipi.tiktok || '') ? 'ios' : /^no/i.test(ipi.tiktok || '') ? 'no' : '';
    // Design v3 RESETT wording
    const Z = { '+8': 'tz_8', '+9': 'tz_9', '+7': 'tz_7', '+0': 'tz_utc' };
    const zm = /UTC\s*([+-]\d+)/i.exec(ipi.reset || '');
    const reset = /24 hours/i.test(ipi.reset || '') ? PT('reset_24h') : zm ? PT('reset_midnight', { zone: Z[zm[1]] ? PT(Z[zm[1]]) : 'UTC' + zm[1], utc: 'UTC' + (zm[1] === '+0' ? '' : zm[1]) }) : '';
    // lc = a local line (runs on the destination's own network: brand SIMs, IIJ/SoftBank/Malaysia/Vietnam local) → Local eSIM tab.
    // local = exit IP in this destination → "Local IP" tag on Travel options.
    return { ...f, cov, carrier, carrierL, local: isLocal, lc: f.local === true || !!f.retail, tt, reset, gkey: uniq(cov.map(c => c.iso)).sort().join('|'), best: false };
  });
  const famBy = Object.fromEntries(fams.map(f => [f.h, f]));
  // Two lines (design CHANGES-2026-09-26b §2): Travel eSIM, and Local eSIM (local lines). A country whose local line is a
  // single fixed product (UK EE, Singapore SIMBA, Russia MTS, Canada Telus, Laos Unitel) shows that product's own view.
  const FIXED = fams.filter(f => f.fixed);
  const dataFams = fams.filter(f => !f.fixed);
  const travelFams = dataFams.filter(f => !f.lc), localFams = dataFams.filter(f => f.lc);
  const HAS_LOCAL = localFams.length > 0 || FIXED.length > 0;
  // plan: {fam, id, label, kind, days, price, after, flat, hotspot, note}
  const toPlan = f => ([id, label, kind, days, price, after, flat, hotspot, note]) => ({ fam: f.h, id, label, kind, days, price, after, flat: !!flat, hotspot, note });
  // Design v3 ordering: home first, then this fixed list, then A–Z.
  const PRI = [HOME, 'China', 'Hong Kong', 'Macau', 'Taiwan', 'Japan', 'South Korea', 'Singapore', 'Thailand', 'Malaysia', 'Vietnam'];
  const ordered = names => names.slice().sort((a, b) => { const ia = PRI.indexOf(a), ib = PRI.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b); });
  const groupsOf = list => {
    const out = [];
    list.forEach(f => {
      let g = out.find(x => x.key === f.gkey);
      if (!g) { g = { key: f.gkey, countries: [], fams: [] }; out.push(g); }
      g.fams.push(f.h);
      f.cov.forEach(c => { if (!g.countries.find(x => x.iso === c.iso)) g.countries.push(c); });
    });
    out.forEach(g => { g.n = g.countries.length; g.names = ordered(g.countries.map(c => c.name)); });
    return out.sort((a, b) => a.n - b.n || a.fams.length - b.fams.length);
  };
  const LINES = { travel: { plans: travelFams.flatMap(f => f.v.map(toPlan(f))), groups: groupsOf(travelFams) },
                  local: { plans: localFams.flatMap(f => f.v.map(toPlan(f))), groups: groupsOf(localFams) } };
  let plans = LINES.travel.plans, groups = LINES.travel.groups;
  // Design v3 labelOf: "X only" · Greater China · "A + B (+ C)" · plan name for bigger bundles.
  const groupLabel = g => {
    if (g.n === 1) return PT('only', { home: HOME_L });
    if (g.n <= 4 && ['China', 'Hong Kong', 'Macau'].every(x => g.names.includes(x))) return PT('greater_china');
    if (g.n <= 3) return g.names.map(L).join(PT('plus'));
    const fb = famBy[g.fams[0]];
    return PT.lang === 'en' ? fb.name : fb.nameL || fb.name; // translated product title on other languages
  };
  // Design v3 "adds" sub-line under each coverage option.
  const groupSub = g => {
    const extra = g.names.filter(n => n !== HOME).map(L), sep = PT('list_sep');
    return g.n <= 2 ? '' : g.n <= 4 ? g.names.map(L).join(sep) : extra.slice(0, 4).join(sep) + (extra.length > 4 ? ' +' + (extra.length - 4) : '');
  };
  const nameOfIso = iso => { for (const g of groups) { const c = g.countries.find(x => x.iso === iso); if (c) return c.name; } return iso; };
  const isoOf = name => { for (const g of groups) { const c = g.countries.find(x => x.name === name); if (c) return c.iso; } return ''; };

  /* ---------- plan keys ---------- */
  const size = label => { const m = /([\d.]+)\s*(GB|MB)/.exec(label); return m ? parseFloat(m[1]) / (m[2] === 'MB' ? 1000 : 1) : 0; };
  const amtOf = p => p.kind === 'daily' ? p.label.replace(' / day', '') : p.label; // "10 GB" / "1 GB" (per day)
  const itemLabel = p => p.kind === 'unl' ? (p.after === '5G' ? PT('full_speed') : p.after) : p.kind === 'daily' ? PT('per_day_amt', { amt: p.label.split(' / day')[0] }) + (p.label.split(' / day')[1] || '') : p.label; // "11 GB / day · LTE" → "11 GB/Tag · LTE"
  // A fixed line's amount in a sentence: daily lines say "11 GB a day" (the label's " · LTE" network stays in the row title).
  const fxAmt = p => p.kind === 'daily' ? p.label.split(' / day')[0] : itemLabel(p);
  const dataShort = p => p.kind === 'unl' ? PT('unlimited') : itemLabel(p);
  // Design (CHANGES-product-page §1): each option says what it's good for.
  const hotOK = p => { const f = famBy[p.fam] || {}; return !p.hotspot && !(f.retail && !['yes', 'apn'].includes(((f.meta || {}).rules || {}).hotspot)); };
  const USE = (a, flat, hot) => a === '5G' ? [PT('use_5g_t'), PT('use_5g_s')]
    : a === '10 Mbps' ? [PT(hot ? 'use_10_t_hot' : 'use_10_t_call'), PT('use_10_s' + (hot ? '_hot' : '') + (flat ? '_flat' : ''))]
    : [PT('use_def_t'), PT('use_def_s')];
  const DH = p => { const n = size(p.label); return PT(n <= 0.5 ? 'dh_05' : n <= 1 ? 'dh_1' : n <= 2 ? 'dh_2' : n <= 3 ? 'dh_3' : n <= 5 ? 'dh_5' : hotOK(p) ? 'dh_hot' : 'dh_big'); };
  const tileLabel = p => p.kind === 'unl' ? (p.after === '5G' ? PT('full_5g') : p.flat ? PT('steady', { speed: p.after }) : p.after) : itemLabel(p);
  const isPop = p => (p.kind === 'total' && S.days === 7 && p.label === '10 GB') || (p.kind === 'daily' && size(p.label) === 1) || (p.kind === 'unl' && !p.flat && p.after === '5 Mbps');

  /* ---------- traits & dedupe (design §4.3) ---------- */
  // Apps: only limits are shown (owner 2026-10-31); ChatGPT, Gemini and TikTok working is what customers expect.
  const appsLim = f => !f.apps ? (f.appsStatus === 'no' ? 'noapps' : 'mayapps') : f.tt === 'ios' ? 'tt_ios' : f.tt === 'no' ? 'tt_no' : '';
  const apnFor = f => (/set the apn to\s*([\w.-]+)/i.exec((f.ipi || {}).note || '') || [])[1] || '';
  const traits = p => { const f = famBy[p.fam]; return { carrier: f.carrier, carrierL: f.carrierL, local: !!f.local, apps: !!f.apps, tt: f.tt, best: f.best, exit: f.ipLabel || f.ip, retail: !!f.retail }; };
  const dedupe = L => { const seen = {}; L.forEach(p => { const t = traits(p); const k = t.carrier + '|' + t.local + '|' + t.apps + '|' + t.exit; if (!seen[k] || p.price < seen[k].price) seen[k] = p; }); return Object.values(seen).sort((a, b) => a.price - b.price); };

  /* ---------- state ---------- */
  const qp = new URLSearchParams(location.search).get('p');
  const S = { line: 'travel', product: -1, fx: 0, cov: '', days: 7, sel: '10 GB', pick: null, qty: 1, netsAll: false, ctyOpen: false, showAll: false, added: false, busy: false };
  function setLine(line) {
    S.line = line; S.pick = null; S.netsAll = false; S.showAll = false; S.added = false; S.qty = 1; S.fx = 0;
    ({ plans, groups } = LINES[line]);
    S.product = line === 'local' && !plans.length && FIXED.length ? 0 : -1;
    const hg = groups.find(g => g.n === 1) || groups[0];
    S.cov = hg ? hg.key : '';
  }
  setLine((qp === 'local' && HAS_LOCAL) || !LINES.travel.plans.length ? (HAS_LOCAL ? 'local' : 'travel') : 'travel');
  // ?variant=<id> (a product link, e.g. from Google Shopping): open with exactly that plan selected and priced.
  const wantV = +(new URLSearchParams(location.search).get('variant') || 0);
  if (wantV) {
    const line = ['travel', 'local'].find(l => LINES[l].plans.some(p => +p.id === wantV));
    const fi = FIXED.findIndex(f => f.v.some(v => +v[0] === wantV));
    if (line) {
      const hit = LINES[line].plans.find(p => +p.id === wantV);
      setLine(line); S.cov = famBy[hit.fam].gkey; S.days = hit.days; S.sel = hit.label; S.pick = hit.fam;
    } else if (fi >= 0) {
      setLine('local'); S.product = fi; S.fx = FIXED[fi].v.findIndex(v => +v[0] === wantV);
    }
  }
  const narrow = () => window.innerWidth < 980;

  const inGroup = key => plans.filter(p => famBy[p.fam].gkey === key);
  const RATE = n => n >= 3 ? 0.10 : n >= 2 ? 0.05 : 0;

  function compute() {
    const PC = inGroup(S.cov);
    const allDays = uniq(PC.map(p => p.days)).sort((a, b) => a - b);
    if (!allDays.includes(S.days) && allDays.length) S.days = allDays.reduce((best, d) => Math.abs(d - S.days) < Math.abs(best - S.days) ? d : best, allDays[0]);
    const D = PC.filter(p => p.days === S.days);
    let matches = D.filter(p => p.label === S.sel);
    if (!matches.length && D.length) {
      const fb = D.find(p => p.label === '10 GB') || D.find(p => p.label === '1 GB / day') || D.slice().sort((a, b) => a.price - b.price)[0];
      S.sel = fb.label; matches = D.filter(p => p.label === S.sel);
    }
    matches = dedupe(matches);
    // Hide dominated options: another option costs no more and is at least as good on carriers, apps, local and coverage (design §4).
    matches = matches.filter(p => {
      const tp = traits(p), op = tp.carrier.split(' & ');
      return !matches.some(q => {
        if (q === p || q.price > p.price) return false;
        const tq = traits(q), oq = tq.carrier.split(' & ');
        return op.every(o => oq.includes(o)) && (tq.apps || !tp.apps) && (tq.local || !tp.local) && tq.exit === tp.exit && (oq.length > op.length || q.price < p.price);
      });
    });
    // A plan opened by link stays visible even if another option would normally hide it.
    if (S.pick && !matches.some(p => p.fam === S.pick)) { const forced = D.find(p => p.fam === S.pick && p.label === S.sel); if (forced) matches.push(forced); }
    const cur = matches.find(p => p.fam === S.pick) || matches[0] || null;
    return { PC, D, allDays, matches, cur };
  }

  /* ---------- render: buy box ---------- */
  const box = root.querySelector('[data-buybox]');
  const sticky = root.querySelector('[data-sticky-buy]');

  // Option tags: id → colour; the text is PT('tag_' + id).
  const TAGC = { lowest: 'green', localip: 'blue', best: 'orange', noapps: 'orange', mayapps: 'orange', tt_ios: 'orange', tt_no: 'orange', refundable: 'green', group: 'green', norefund: 'orange', once: 'orange' };
  const tagText = t => typeof t === 'string' ? PT('tag_' + t) : PT('tag_ipin', { place: PT.d(t.place) });
  const IC = { ip: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z', apps: 'M12 3 4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6z', phone: 'M7 3h10v18H7zM11 18h2', cal: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4', net: 'M4 20v-3M9 20v-7M14 20V9M19 20V4', data: 'M12 3v12m0 0-4-4m4 4 4-4M5 21h14', hot: 'M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M12 19.5h.01' };
  const TICK = 'M5 12.5 10 17l9-10';
  const WARN = 'M12 8v5M12 16.5h.01M10.3 3.9 2.6 17.5a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z';
  // Under Add to cart: quiet, centred (design CHANGES §3) — the buttons stay the visual focus.
  const trustHtml = refund => `<div class="trust">
      <div class="trust__row"><span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A817C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16v12H4zM4 7l8 6 8-6"/></svg>${esc(PT('trust_qr'))}</span><span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A817C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4"/></svg>${refund}</span></div>
      <a class="trust__link" href="${window.PT.url('pages/phone-check')}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM11 18h2"/></svg>${esc(PT('trust_phone'))}</a>
    </div>`;

  // Travel eSIM / Local eSIM (design CHANGES-2026-09-26b §2). "Number" badge when a local line comes with a phone number.
  const NUMB = f => /number|号码|號碼|門號/i.test([(f.meta || {}).label, (f.meta || {}).desc, ...(((f.meta || {}).features) || [])].join(' '));
  const minPrice = L => L.length ? Math.min(...L) : null;
  const tabsHtml = () => {
    if (!HAS_LOCAL || !LINES.travel.plans.length) return '';
    const tMin = minPrice(LINES.travel.plans.map(p => p.price));
    const lMin = minPrice([...LINES.local.plans.map(p => p.price), ...FIXED.flatMap(f => f.v.map(v => v[4]))]);
    const number = [...localFams, ...FIXED].some(NUMB);
    const tab = (line, label, sub, badge) => `<button type="button" class="seg-tall__tab${S.line === line ? ' is-on' : ''}" data-action="line" data-v="${line}" aria-pressed="${S.line === line}"><span class="seg-tall__label">${esc(label)}${badge ? `<span class="seg-tall__badge">${badge}</span>` : ''}</span><span class="seg-tall__from">${lMin == null && line === 'local' ? '' : PT('from', { price: money(line === 'local' ? lMin : tMin) })}</span></button>`;
    return `<div class="seg-tall seg-tall--auto">${tab('travel', PT('tab_travel'), '')}${tab('local', PT('tab_local'), '', number ? esc(PT('badge_number')) : '')}</div>`;
  };

  /* ---------- network strip + the six detail cards (design CHANGES-2026-09-26b §1) ---------- */
  const DC = ['red', 'blue', 'green', 'orange', 'purple', 'slate'];
  // a card with no text is left out; the others keep their colours
  const detailsHtml = details => `<div class="detail-grid detail-grid--3">${details.map((d, i) => ({ ...d, c: DC[i] })).filter(d => d.v).map(d => `<div class="detail"><span class="detail__icon detail__icon--${d.c || 'slate'}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="${d.icon}"/></svg></span><div><div class="detail__k">${esc(d.k)}</div><div class="detail__v">${esc(d.v)}</div>${d.sub ? `<div class="detail__sub">${esc(d.sub)}</div>` : ''}</div></div>`).join('')}</div>`;
  // countries: [{iso, name, ops, g5}] · home carrier text · (local) suffix for local lines
  // A fixed line shown on another country's page (Monaco sells the UK EE line) is local to its own home country.
  const lineHome = f => f.homeIso && f.homeIso !== HOME_ISO ? PT.country(f.homeIso) : HOME_L;

  // countries: the selected option's own coverage. Not the group's (the group lists each country once, with the networks
  // of whichever option came first: "In China: China Telecom & China Unicom" over a list saying only China Telecom).
  function stripHtml(countries, carrier, isLocalLine) {
    const n = countries.length;
    if (n <= 1) {
      if (!carrier) return '';
      return `<div class="net-strip"><div class="net-strip__row"><span class="net-strip__flags">${flagImg(HOME_ISO, 26)}</span><div class="net-strip__text"><div class="net-strip__k">${esc(PT('network'))}</div><div class="net-strip__v">${esc(carrier)}${isLocalLine ? esc(PT('local_suffix')) : ''}</div></div></div></div>`;
    }
    const opsOf = c => uniq((c.ops || []).map(OPN));
    // A place the supplier lists without a network (UK EE line: Guernsey, Jersey, Isle of Man): the phone picks one itself
    const nOps = uniq(countries.flatMap(opsOf)).length;
    const names = ordered(countries.map(c => c.name));
    const byName = Object.fromEntries(countries.map(c => [c.name, c]));
    const hasNets = countries.some(c => (c.ops || []).length);
    const list = hasNets && S.netsAll ? `<div class="net-strip__list">${names.map(nm => { const c = byName[nm]; return `<div class="nets-list__row">${flagImg(c.iso, 20)}<span class="nets-list__name">${esc(L(nm))}</span><span class="nets-list__ops">${esc(opsOf(c).length ? PT.amp(opsOf(c).map(PT.op)) : PT('ops_auto'))}</span>${c.g5 ? '<span class="nets-list__5g">5G</span>' : ''}</div>`; }).join('')}</div>` : '';
    const sub = carrier ? PT('in_home', { home: HOME_L, carrier: carrier.replace(/ & (?=.* & )/g, ', ') }) + (isLocalLine ? PT('local_suffix') : '') : '';
    return `<div class="net-strip"><div class="net-strip__row">
        <span class="net-strip__flags">${names.slice(0, 3).map(nm => flagImg(byName[nm].iso, 26)).join('')}</span>
        <div class="net-strip__text"><div class="net-strip__k">${esc(PT('works_in'))}</div><div class="net-strip__v">${esc(PT.n('n_dest', n))}${hasNets ? esc(PT.n('n_nets', nOps)) : ''}</div>${sub ? `<div class="net-strip__sub">${esc(sub)}</div>` : ''}</div>
        ${hasNets ? `<button type="button" class="net-strip__btn" data-action="nets" aria-expanded="${S.netsAll}">${esc(PT(S.netsAll ? 'hide_nets' : 'nets_by_country'))}<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="${S.netsAll ? 'm6 15 6-6 6 6' : 'm6 9 6 6 6-6'}"/></svg></button>` : ''}
      </div>${list}</div>`;
  }
  const IC_START = 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2';
  const IC_CALL = 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2';
  // Days start / How days count
  const startCard = rules => rules.dayMode === 'JST' ? { k: PT('how_days'), v: PT('jst'), icon: IC.cal }
    : rules.activation === 'download' ? { k: PT('days_start'), v: PT('start_install'), icon: IC_START }
    : { k: PT('days_start'), v: PT('start_connect'), icon: IC_START };
  // Install (install-by window + how many times) — kept on purpose: local lines that install once must say so.
  const installCard = (days, once) => ({ k: PT('install'), v: PT('install_within', { n: days || 90 }), sub: once ? PT('install_once') : '', icon: IC.cal }); // no reinstall count on travel eSIMs
  const hotspotCard = (cur, rules) => ({ k: PT('hotspot'), v: cur.hotspot ? PT('hotspot_cap', { amt: String(cur.hotspot).replace('GB', ' GB') }) : PT(rules.hotspot === 'apn' ? 'hotspot_apn' : 'hotspot_ok'), icon: IC.hot });
  // Local-tab options carry their rules (refund / group discount / installs differ between brand SIMs and pool local lines).
  const ruleTags = f => f.retail ? ['norefund', 'once'] : ['refundable', 'group'];
  const REFUND_LOCAL = PT('refund_local');

  function renderFixed() {
    const f = FIXED[S.product], m = f.meta || {}, rules = m.rules || {};
    const opts = f.v.map(toPlan(f));
    const cur = opts[Math.min(S.fx, opts.length - 1)];
    const dl = d => PT.n('n_days', d);
    const appsV = f.appsStatus === 'works' ? '' : (rules.blocked || []).length ? PT('apps_blocked', { apps: rules.blocked.join(PT('list_sep')) }) : PT('apps3_wont');
    const mins = /(\d[\d,]*) mins/.exec(cur.note || '');
    const calls = mins ? PT('calls_uk', { mins: mins[1] }) : m.calls;
    const details = [
      { k: PT('ip_in'), v: PT.d(f.ipLabel || f.ip) || PT('not_confirmed'), icon: IC.ip },
      { k: PT('data'), v: PT(cur.kind === 'daily' ? 'fx_data_daily' : 'fx_data', { amt: fxAmt(cur), days: dl(cur.days) }) + (cur.after ? PT('fx_then', { after: cur.after }) : ''), icon: IC.data },
      { k: PT('apps'), v: appsV, icon: IC.apps },
      calls ? { k: PT('calls'), v: calls, icon: IC_CALL } : hotspotCard(cur, rules),
      startCard(rules),
      installCard(f.install, rules.installs !== '5-same')
    ];
    return `<div>
        <div class="fx-title">${esc(PT.d(m.label) || f.name)}</div>
        <div class="fx-desc">${esc(PT.d(m.desc) || '')}</div>
        <div class="net-list">${opts.map((o, i) => `<button type="button" class="radio-row${o === cur ? ' is-on' : ''}" data-action="fx" data-v="${i}" aria-pressed="${o === cur}"><span class="radio-dot"></span>
          <span class="radio-row__main"><span class="radio-row__title">${esc(itemLabel(o))} · ${dl(o.days)}</span>${o.note ? `<span class="fx-note">${esc(PT.d(o.note))}</span>` : ''}</span><span class="fx-price">${money(o.price)}</span></button>`).join('')}</div>
        ${(m.features || []).length ? `<div class="fx-features">${m.features.map(x => `<span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1F7A3F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${TICK}"/></svg>${esc(PT.d(x))}</span>`).join('')}</div>` : ''}
      </div>
      <div class="bb-price">
        <div class="bb-price__row"><div class="bb-price__main"><span class="price-xl">${money(cur.price)}</span></div><div class="muted-13">${esc(PT('per_day_price', { price: money(cur.price / cur.days) }))}</div></div>
        <div class="summary">
          <div class="summary__plain">${esc(PT(cur.kind === 'daily' ? 'fx_plain_daily' : 'fx_plain', { amt: fxAmt(cur), days: dl(cur.days), home: lineHome(f) }))}</div>
          ${rules.tip ? `<div class="after-line is-warn"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${WARN}"/></svg>${esc(PT.d(rules.tip))}</div>` : ''}
          ${stripHtml(f.cov, f.carrierL || PT.op(((f.cov[0] || {}).ops || [])[0] || ''), !f.homeIso || f.homeIso === HOME_ISO)}
          ${detailsHtml(details)}
        </div>
        <div class="buy-btns"><button type="button" class="btn-add" data-action="add" data-add-main${S.busy ? ' disabled' : ''}>${addLabel()}</button><button type="button" class="btn-buy" data-action="buy"${S.busy ? ' disabled' : ''}>${esc(PT('buy_now'))}</button></div>
        ${trustHtml(esc(REFUND_LOCAL))}
      </div>`;
  }

  function render() {
    if (S.product >= 0) {
      box.innerHTML = tabsHtml() + renderFixed();
      const f = FIXED[S.product], o = f.v.map(toPlan(f))[Math.min(S.fx, f.v.length - 1)];
      sticky.querySelector('[data-sticky-summary]').textContent = PT('sticky_local', { data: itemLabel(o), n: o.days });
      sticky.querySelector('[data-sticky-price]').textContent = money(o.price);
      sticky.querySelector('[data-action="add"]').textContent = addLabel();
      renderWhere();
      observeAdd();
      return;
    }
    if (!plans.length) { box.innerHTML = tabsHtml() + `<div class="buybox__loading">${esc(PT('no_plans'))}</div>`; return; }
    const { D, allDays, matches, cur } = compute();
    const g = groups.find(x => x.key === S.cov) || groups[0];
    const multi = g.n > 1;
    const others = g.names.filter(n => n !== HOME);
    const phrase = others.length <= 2 ? andJoin([HOME_L, ...others.map(L)]) : PT('phrase_more', { a: HOME_L, b: L(others[0]), n: others.length - 1 });
    const f = cur ? famBy[cur.fam] : null;

    // Where are you going? (design v3 default: coverage radio list at the top of the buy box)
    let html = tabsHtml() + (groups.length < 2 ? '' : `<div>
      <div class="bb-row"><span class="bb-label">${esc(PT('where'))}</span></div>
      <div class="cov-list">${covRows(cur).map(r => `<button type="button" class="radio-row radio-row--cov${r.on ? ' is-on' : ''}" data-action="cov" data-v="${esc(r.g.key)}" aria-pressed="${r.on}"><span class="radio-dot"></span>
        <span class="radio-row__main"><span class="radio-row__title">${esc(groupLabel(r.g))}${r.g.n > 1 ? ` <span class="cov-n">${esc(PT('cov_n', { n: r.g.n }))}</span>` : ''}</span>${r.q ? `<span class="cov-q">${esc(r.q)}</span>` : ''}</span>
        <span class="radio-row__delta${r.good ? ' is-good' : ''}">${esc(r.delta)}</span></button>`).join('')}</div>
      ${covMore ? `<button type="button" class="cov-more" data-action="more">${esc(covMore)}</button>` : ''}
    </div>`);

    // Days
    html += `<div><div class="bb-row mb-12"><span class="bb-label">${esc(PT('how_many_days'))}</span></div>
      <div class="day-grid">${allDays.map(d => `<button type="button" class="chip${S.days === d ? ' is-on' : ''}" data-action="days" data-v="${d}" aria-pressed="${S.days === d}">${d}</button>`).join('')}</div></div>`;

    // Plan type tabs + items
    const kinds = [['total', PT('k_total'), PT('k_total_d')], ['daily', PT('k_daily'), PT('k_daily_d')], ['unl', PT('k_unl'), PT('k_unl_d')]];
    const activeKind = cur ? cur.kind : 'total';
    const minOf = k => { const L = D.filter(p => p.kind === k); return L.length ? Math.min(...L.map(p => p.price)) : null; };
    html += `<div><div class="seg-tall" role="tablist">${kinds.map(([k, label]) => { const m = minOf(k);
      return `<button type="button" role="tab" class="seg-tall__tab${activeKind === k ? ' is-on' : ''}"${m == null ? ' disabled' : ''} data-action="kind" data-v="${k}" aria-selected="${activeKind === k}"><span class="seg-tall__label">${esc(label)}</span><span class="seg-tall__from">${m == null ? esc(PT('na')) : PT('from', { price: money(m) })}</span></button>`; }).join('')}</div>`;
    const seen = {};
    D.filter(p => p.kind === activeKind).forEach(p => { if (!seen[p.label] || p.price < seen[p.label].price) seen[p.label] = p; });
    const items = Object.values(seen).sort((a, b) => activeKind === 'unl' ? a.price - b.price : size(a.label) - size(b.label));
    const wide = activeKind !== 'total';
    html += `<div class="group-note">${esc(kinds.find(k => k[0] === activeKind)[2])}</div>
      <div class="tile-grid${wide ? ' tile-grid--2' : ''}">${items.map(p => {
        const hint = p.kind === 'unl' ? USE(p.after, p.flat, hotOK(p))[0] : p.kind === 'daily' ? DH(p) : '';
        const hint2 = p.kind === 'unl' && !p.flat && p.after !== '5G' ? PT('hint_1gb') : '';
        return `<button type="button" class="tile${wide ? ' tile--wide' : ''}${cur && cur.label === p.label ? ' is-on' : ''}" data-action="plan" data-v="${esc(p.label)}">${isPop(p) ? `<span class="tile__pop">${esc(PT('popular'))}</span>` : ''}<span class="tile__label">${esc(tileLabel(p))}</span>${hint ? `<span class="tile__hint">${esc(hint)}</span>` : ''}${hint2 ? `<span class="tile__hint2">${esc(hint2)}</span>` : ''}<span class="tile__price">${money(p.price)}</span></button>`; }).join('')}</div></div>`;

    // Network picker (only if ≥2 after de-dup)
    if (matches.length > 1) {
      const lims = matches.map(p => appsLim(famBy[p.fam])), sameLim = uniq(lims).length === 1;
      const sameExit = uniq(matches.map(p => traits(p).exit)).length === 1;
      // Rule tags only when the options differ (a brand SIM next to a pool local line); otherwise the cards say it once.
      const sameRules = uniq(matches.map(p => !!famBy[p.fam].retail)).length === 1;
      html += `<div><div class="bb-label mb-10">${esc(PT('network'))}</div><div class="net-list">${matches.map((p, i) => {
        const t = traits(p), on = cur && cur.fam === p.fam, tags = [];
        if (i === 0) tags.push('lowest');
        if (lims[i] && !sameLim) tags.push(lims[i]);
        if (S.line === 'local') { if (!sameRules) tags.push(...ruleTags(famBy[p.fam])); }
        else { if (t.local) tags.push('localip'); if (t.best) tags.push('best');
          if (t.exit && !sameExit) tags.push({ place: t.exit.replace(/ \(.*\)$/, '') }); }
        return `<button type="button" class="radio-row${on ? ' is-on' : ''}" data-action="pick" data-v="${esc(p.fam)}" aria-pressed="${on}"><span class="radio-dot"></span>
          <span class="radio-row__main"><span class="radio-row__title">${esc(t.carrierL)}</span><span class="tag-row">${tags.slice(0, 3).map(x => `<span class="tag tag--${TAGC[x] || 'slate'}">${esc(tagText(x))}</span>`).join('')}</span></span>
          <span class="radio-row__delta">${i === 0 ? '' : p.price === matches[0].price ? esc(PT('same_price')) : '+' + money(p.price - matches[0].price)}</span></button>`; }).join('')}</div></div>`;
    }

    // Price + summary
    if (cur) {
      const groupOk = !f.retail; // local SIM lines (KDDI) aren't in the group discount
      const q = S.qty, r = groupOk ? RATE(q) : 0, full = cur.price * q;
      // what happens after is said once, in the line below (design 2026-09-26c §1)
      const pv = { days: PT.n('n_days', S.days), across: multi ? PT('across', { places: phrase }) : '', amt: amtOf(cur), speed: cur.after, carrier: f.carrierL };
      const plain = PT(cur.kind === 'unl' ? (cur.after === '5G' ? 'p_unl5g' : cur.flat ? 'p_unl_flat' : 'p_unl') : cur.kind === 'daily' ? 'p_daily' : 'p_total', pv);

      let after, good = true, icon = TICK;
      if (cur.kind === 'unl') after = USE(cur.after, cur.flat, hotOK(cur))[1];
      else if (cur.after && /kbps/.test(cur.after)) { after = PT(cur.kind === 'daily' ? 'after_kbps_daily' : 'after_kbps_total', { amt: amtOf(cur), speed: cur.after }); good = false; icon = WARN; }
      else if (!cur.after) { after = PT('after_stop'); good = false; icon = WARN; }
      else after = PT('after_slow', { speed: cur.after });

      const rules = (f.meta || {}).rules || {};
      const lim = appsLim(f), apn = apnFor(f);
      const appsV = lim ? PT({ noapps: 'apps3_wont', mayapps: 'apps_maynot', tt_ios: 'apps_ios', tt_no: 'apps_nott' }[lim]) : apn ? PT('apps_apn', { apn }) : '';
      const details = [
        { k: PT('ip_in'), v: PT.d(f.ipLabel || f.ip) || PT('not_confirmed'), icon: IC.ip },
        { k: PT('data'), v: cur.kind === 'unl' ? (cur.after === '5G' ? PT('d_unl5g') : PT(cur.flat ? 'd_unl_flat' : 'd_unl', { speed: cur.after })) : cur.kind === 'daily' ? PT('d_daily', { amt: amtOf(cur), reset: f.reset || PT('reset_daily') }) : PT('d_total', { amt: amtOf(cur) }), icon: IC.data },
        { k: PT('apps'), v: appsV, icon: IC.apps },
        hotspotCard(cur, rules),
        startCard(rules),
        installCard(f.install, f.retail ? rules.installs !== '5-same' : false)
      ];
      html += `<div class="bb-price">
        <div class="bb-price__row"><div><div class="bb-price__main"><span class="price-xl">${money(full * (1 - r))}</span>${r > 0 ? `<span class="price-was">${money(full)}</span>` : ''}</div>
          ${q > 1 ? `<div class="price-note">${esc(PT('n_esims', { n: q }))}${r > 0 ? esc(PT('you_save', { money: money(full * r) })) : ''}</div>` : ''}</div>
          <div class="muted-13">${esc(PT('per_day_price', { price: money(cur.price / S.days) }))}</div></div>
        <div class="summary">
          <div class="summary__plain">${esc(plain)}</div>
          <div class="after-line${good ? '' : ' is-warn'}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${icon}"/></svg>${esc(after)}</div>
          ${stripHtml(f.cov, f.carrierL, f.lc)}
          ${detailsHtml(details)}
          ${(f.cov.find(c => c.iso === HOME_ISO) || {}).kyc ? `<div class="after-line is-warn"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 15h4M7 11h2M15 10.5a1.5 1.5 0 1 0 0 .01"/></svg>${esc(PT('kyc', { home: HOME_L }))}</div>` : ''}
        </div>
        ${groupOk ? `<div class="group-disc"><div class="group-disc__text"><div class="group-disc__head"><span class="group-disc__title">${esc(PT('how_many_esims'))}</span><span class="group-disc__badge">${q >= 3 ? '−10%' : q === 2 ? '−5%' : esc(PT('save_upto'))}</span></div>
          <div class="group-disc__tier${q > 1 ? ' is-active' : ''}">${esc(PT(q >= 3 ? 'saving_10' : q === 2 ? 'saving_5' : 'tiers'))}</div></div>
          <div class="stepper"><button type="button" class="stepper__btn" data-action="qty" data-v="-1" aria-label="${esc(PT('fewer'))}"${q <= 1 ? ' disabled' : ''}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M5 12h14"/></svg></button><span class="stepper__n">${q}</span><button type="button" class="stepper__btn" data-action="qty" data-v="1" aria-label="${esc(PT('more'))}"${q >= 10 ? ' disabled' : ''}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div></div>` : ''}
        <div class="buy-btns"><button type="button" class="btn-add" data-action="add" data-add-main${S.busy ? ' disabled' : ''}>${addLabel()}</button><button type="button" class="btn-buy" data-action="buy"${S.busy ? ' disabled' : ''}>${esc(PT('buy_now'))}</button></div>
        ${trustHtml(esc(f.retail ? REFUND_LOCAL : PT('refund_30')))}
      </div>`;
      sticky.querySelector('[data-sticky-summary]').textContent = PT('sticky', { data: dataShort(cur), days: PT.n('n_days', S.days), carrier: f.carrierL });
      sticky.querySelector('[data-sticky-price]').textContent = money(full * (1 - r));
      sticky.querySelector('[data-action="add"]').textContent = addLabel();
    }
    box.innerHTML = html;
    renderWhere();
    observeAdd();
  }

  const addLabel = () => esc(S.busy ? PT('adding') : S.added ? PT('added') : S.qty > 1 ? PT('add_n', { n: S.qty }) : PT('add'));

  /* ---------- coverage options (Where are you going?) ---------- */
  let covMore = '';
  const theName = () => DATA.nameThe || DATA.name; // "the Netherlands" in English, the plain name in other languages
  function covRows(cur) {
    const curPrice = cur ? cur.price : null;
    let rows = groups.map(g => {
      const on = g.key === S.cov;
      const G = inGroup(g.key);
      const exact = G.filter(p => p.days === S.days && cur && p.label === cur.label).sort((a, b) => a.price - b.price)[0];
      const min = G.reduce((m, p) => Math.min(m, p.price), Infinity);
      let delta = '', good = false;
      if (!on) {
        if (exact && curPrice != null) { const d = exact.price - curPrice; good = d < 1; delta = Math.abs(d) < 1 ? PT('same_price') : (d > 0 ? '+' : '−') + money(Math.abs(d)); }
        else if (isFinite(min)) delta = PT('from', { price: money(min) });
      }
      return { g, on, delta, good, q: groupSub(g) };
    });
    const NK = 3, selIdx = rows.findIndex(r => r.on);
    covMore = '';
    if (!S.showAll && rows.length > NK) {
      const keep = rows.slice(0, NK); if (selIdx >= NK) keep.push(rows[selIdx]);
      const n = rows.length - keep.length;
      covMore = PT.n('show_more', n, { country: theName() });
      rows = keep;
    } else if (rows.length > NK) covMore = PT('show_fewer');
    return rows;
  }
  function renderWhere() { renderRoute(); }

  /* ---------- "Going on to …?" border chips (HK / Macau pages) ---------- */
  const routeChips = root.querySelector('[data-route-chips]');
  const routeNote = root.querySelector('[data-route-note]');
  const stopLabel = n => n === 'China' ? PT('mainland_china') : L(n);
  function renderRoute() {
    if (!routeChips || !CFG.route) return;
    const g = groups.find(x => x.key === S.cov) || groups[0];
    const off = !g || groups.length < 2; // e.g. the Local line: nothing to add stops to, so the chips would do nothing
    routeChips.closest('section').hidden = off;
    if (off) return;
    const stops = CFG.route.stops.map(nameOfIso);
    const inCov = n => g.names.includes(n);
    routeChips.innerHTML = stops.map((n, i) => {
      const on = inCov(n), home = i === 0;
      return `<button type="button" class="route-chip${on ? ' is-on' : ''}${home ? ' is-home' : ''}" data-action="route" data-v="${esc(n)}"${home ? ' disabled' : ''}>${flagImg(isoOf(n), 24)}<span>${esc(stopLabel(n))}</span>${home ? '' : `<span class="route-chip__mark">${on ? '✓' : esc(PT('add_stop'))}</span>`}</button>`;
    }).join('');
    const extra = stops.slice(1).filter(inCov).map(stopLabel);
    routeNote.textContent = extra.length ? PT('route_covers', { list: andJoin([L(stops[0]), ...extra]) }) : PT('route_only', { place: L(stops[0]) });
  }
  function routeTo(toggle) {
    const g = groups.find(x => x.key === S.cov) || groups[0];
    if (!g) return;
    const stops = CFG.route.stops.map(nameOfIso);
    const cur = stops.filter(n => g.names.includes(n));
    const want = cur.includes(toggle) ? cur.filter(n => n !== toggle) : [...cur, toggle];
    const excl = stops.filter(n => !want.includes(n));
    const fits = x => want.every(n => x.names.includes(n));
    const target = groups.filter(x => fits(x) && excl.every(n => !x.names.includes(n))).sort((a, b) => a.n - b.n)[0] || groups.filter(fits).sort((a, b) => a.n - b.n)[0];
    if (target) switchCoverage(target.key);
  }

  /* ---------- actions ---------- */
  function switchCoverage(key) {
    const G = inGroup(key);
    if (!G.length) return;
    const { cur } = compute();
    S.cov = key; S.pick = null; S.added = false;
    const exact = G.find(p => p.days === S.days && cur && p.label === cur.label);
    if (!exact) {
      const days = uniq(G.map(p => p.days)).sort((a, b) => Math.abs(a - S.days) - Math.abs(b - S.days))[0];
      const at = G.filter(p => p.days === days);
      const same = cur && at.find(p => p.label === cur.label);
      S.days = days;
      S.sel = same ? same.label : (at.find(p => p.label === '10 GB') || at.slice().sort((a, b) => a.price - b.price)[0]).label;
    }
    render();
  }

  async function addToCart(thenCheckout) {
    let cur, f;
    if (S.product >= 0) { f = FIXED[S.product]; cur = f.v.map(toPlan(f))[Math.min(S.fx, f.v.length - 1)]; S.qty = 1; }
    else { cur = compute().cur; f = cur && famBy[cur.fam]; }
    if (!cur || S.busy) return;
    S.busy = true; render();
    try {
      const props = { _iso: HOME_ISO };
      if (f.retail) props._local = '1';
      const res = await fetch(window.PT.url('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: cur.id, quantity: S.qty, properties: props }] }) });
      if (!res.ok) throw new Error((await res.json()).description || PT('cart_error'));
      if (thenCheckout) { window.location.href = window.PT.url('checkout'); return; }
      S.added = true; S.qty = 1;
      document.dispatchEvent(new CustomEvent('pakyo:cart-open'));
    } catch (e) {
      alert(e.message);
    } finally {
      S.busy = false; render();
    }
  }

  function flashWhere() {
    const el = document.getElementById('where');
    if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    el.classList.add('is-flash'); clearTimeout(flashWhere.t); flashWhere.t = setTimeout(() => el.classList.remove('is-flash'), 1400);
  }

  root.addEventListener('click', e => {
    const b = e.target.closest('[data-action]');
    if (!b || b.disabled) return;
    const v = b.dataset.v;
    switch (b.dataset.action) {
      case 'line': setLine(v); break;
      case 'product': S.product = +v; S.fx = 0; S.added = false; S.qty = 1; break;
      case 'fx': S.fx = +v; S.added = false; break;
      case 'days': S.days = +v; S.pick = null; S.added = false; break;
      case 'kind': { const { D } = compute(); const L = D.filter(p => p.kind === v); const pref = v === 'total' ? '10 GB' : v === 'daily' ? '1 GB / day' : 'Unlimited · 5 Mbps'; const p = L.find(x => x.label === pref) || L.slice().sort((a, c) => a.price - c.price)[0]; if (p) S.sel = p.label; S.pick = null; S.added = false; break; }
      case 'plan': S.sel = v; S.pick = null; S.added = false; break;
      case 'pick': S.pick = v; S.added = false; break;
      case 'qty': S.qty = Math.max(1, Math.min(10, S.qty + +v)); S.added = false; break;
      case 'nets': S.netsAll = !S.netsAll; break;
      case 'toggle-countries': S.ctyOpen = !S.ctyOpen; break;
      case 'change-cov': flashWhere(); return;
      case 'cov': switchCoverage(v); return;
      case 'route': routeTo(v); return;
      case 'more': S.showAll = !S.showAll; break;
      case 'add': addToCart(false); return;
      case 'buy': addToCart(true); return;
      default: return;
    }
    // Keep the clicked control where it was (design CHANGES §1: tabs don't jump when the option grid changes height).
    const sel = `[data-action="${b.dataset.action}"]` + (v != null ? `[data-v="${CSS.escape(v)}"]` : '');
    const top = b.getBoundingClientRect().top;
    render();
    const again = root.querySelector(sel);
    if (again) { const d = again.getBoundingClientRect().top - top; if (Math.abs(d) > 1) window.scrollBy(0, d); }
  });

  /* ---------- sticky mobile bar ---------- */
  let io;
  function observeAdd() {
    if (!('IntersectionObserver' in window)) return;
    const btn = box.querySelector('[data-add-main]');
    if (io) io.disconnect();
    if (!btn) return;
    io = new IntersectionObserver(([en]) => { sticky.hidden = !narrow() || en.isIntersecting || en.boundingClientRect.top > window.innerHeight; document.body.classList.toggle('has-sticky-buy', narrow()); });
    io.observe(btn);
  }
  window.addEventListener('resize', () => { if (!narrow()) sticky.hidden = true; document.body.classList.toggle('has-sticky-buy', narrow()); });

  render();
})();
